<template>
    <div class="container" id="EnrollAuditDetail">
        <el-page-header @back="$router.back()" :content="'参赛者数量统计'"></el-page-header>
        <div class="EnrollAuditDetail_content">
            <el-descriptions>
                <el-descriptions-item label="数据截止时间">
                    <span style="margin-right: 10px;">{{dateTime}}</span>
                    <el-button type="primary" size="small" @click="getDataList()">刷新</el-button>
                </el-descriptions-item>
            </el-descriptions>
            <el-row style="height: calc(100% - 50px)">
                <el-table
                    v-loading="loading"
                    element-loading-text="数据刷新中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    :data="list"
                    border
                    style="width: 100%"
                    height="100%"
                >
                    <el-table-column label="组别" align="center" min-width="150">
                        <template slot-scope="scope">
                            <span>{{scope.row.GroupInfo.Name}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="名额总数" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.TotalNum != null" style="display: inline-block;width: 80px;text-align: right;">
                                {{scope.row.TotalNum}}
                                <template v-if="scope.row.GroupInfo.GroupType == 1">名运动员</template>
                                <template v-else-if="scope.row.GroupInfo.GroupType == 2">支队伍</template>
                                <template v-else-if="scope.row.GroupInfo.GroupType == 3">对组合</template>
                            </span>
                            <span v-else style="display: inline-block;width: 80px;text-align: right;">不限</span>
                            <el-button type="text" style="margin-left: 10px;" @click="openEditLimit(scope.row)">修改</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="已占用名额" align="center">
                        <template slot-scope="scope">
                            <span :class="{
                                'error': scope.row.TotalNum != null && scope.row.OccupyNum > scope.row.TotalNum
                            }">{{scope.row.OccupyNum}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="占用 - 审核通过" align="center">
                        <template slot-scope="scope">
                            <span :class="{
                                'error': scope.row.TotalNum != null && scope.row.OccupyApproveNum > scope.row.TotalNum,
                                'allow': scope.row.TotalNum != null && scope.row.LeftNum == 0 && scope.row.OccupyApproveNum < scope.row.TotalNum
                            }">{{scope.row.OccupyApproveNum}}</span>
                            <el-button type="text" style="margin-left: 10px;" :disabled="scope.row.OccupyApproveNum == 0" @click="openGroupDetail(0, scope.row.GroupInfo)">详情</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="占用 - 保留" align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.OccupyReserveNum}}</span>
                            <el-button type="text" style="margin-left: 10px;" :disabled="scope.row.OccupyReserveNum == 0" @click="openGroupDetail(1, scope.row.GroupInfo)">详情</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="剩余可报名额" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.TotalNum == null">不限</span>
                            <span v-else-if="scope.row.LeftNum > 0">{{scope.row.LeftNum}}</span>
                            <span v-else class="full">满员</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </div>
        <el-dialog :title="`${groupDialog.groupInfo.Name} - ${groupDialog.type == 0 ? '审核通过的参赛者（占用名额）' : '保留名额的参赛者'}`" :visible.sync="groupDialog.show" :width="groupDialog.type == 0 ? '800px' : '900px'" :close-on-click-modal="false">
            <el-table
                :data="groupDialog.list"
                border
                size="small"
                style="width: 100%"
                height="60vh"
            >
                <el-table-column label="序号" type="index" align="center" width="50"></el-table-column>
                <el-table-column label="代表机构" align="center" min-width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row._rowspan === 0 ? '' : (scope.row.CompanyName || '（无）')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="代表队" align="center" width="180">
                    <template slot-scope="scope">
                        <span>{{scope.row._rowspan === 0 ? '' : (scope.row.DeputationName || '（个人报名）')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="数量" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.row._rowspan === 0 ? '' : scope.row.OccupyNum}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="['', '运动员','参赛者','组合'][groupDialog.groupInfo.GroupType]" align="center" width="140">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openTeamDetail(scope.row)" v-if="groupDialog.groupInfo.GroupType == 2">查看</el-button>
                        <el-button type="text" @click="openTeamDetail(scope.row)" v-else>{{scope.row.TeamName}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="释放名额" align="center" width="180" v-if="groupDialog.type == 1">
                    <template slot-scope="scope">
                        <el-button type="text" @click="openOperate(scope.row)">报名操作员</el-button>
                        <el-button type="text" style="color: #f56c6c" @click="deleteTeam(1, scope.row)">强制删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog :title="['个人运动员详情','队伍详情','组合详情'][groupDialog.groupInfo.GroupType - 1]" :visible.sync="teamDialog.show" :close-on-click-modal="false" class="detail_dialog">
            <div v-if="teamDialog.isDelete">
                <p></p>
                <el-descriptions title="该参赛者已被报名操作员删除，但其占用的名额暂时保留未释放。" :column="1" >
                    <el-descriptions-item label="名称">{{teamDialog.baseInfo.TeamName}}</el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="content" v-else>
                <el-descriptions title="报名信息" :column="teamDialog.baseInfo.DeputationName ? 5 : 4" size="small" border direction="vertical" :labelStyle="labelStyle">
                    <el-descriptions-item label="比赛项目">{{teamDialog.baseInfo.EventsName}}</el-descriptions-item>
                    <el-descriptions-item label="组别">{{teamDialog.baseInfo.LeagueGroupName}}</el-descriptions-item>
                    <el-descriptions-item label="代表队" v-if="teamDialog.baseInfo.DeputationName">{{teamDialog.baseInfo.DeputationName}}</el-descriptions-item>
                    <el-descriptions-item label="代表机构">{{teamDialog.baseInfo.CompanyName || '无'}}</el-descriptions-item>
                    <el-descriptions-item label="报名时间">{{dateFormat(teamDialog.baseInfo.EnrollTime, 'yyyy-MM-dd HH:mm')}}</el-descriptions-item>
                </el-descriptions>
                <el-alert type="info" show-icon :closable="false" v-if="teamDialog.baseInfo.DeputationId && [1,3].includes(teamDialog.baseInfo.TeamType)">
                    <template #title>代表队在该组别报名了 {{teamDialog.ThisGroupDeputationEnrollNum}} {{['名运动员','','对组合'][teamDialog.baseInfo.TeamType - 1]}}</template>
                </el-alert>
                <el-descriptions title="报名操作员" :column="3" size="small" border direction="vertical" :labelStyle="labelStyle" v-if="teamDialog.operateInfo">
                    <el-descriptions-item label="姓名">{{teamDialog.operateInfo.Name}}</el-descriptions-item>
                    <el-descriptions-item label="手机号">{{teamDialog.operateInfo.Phone}}</el-descriptions-item>
                    <el-descriptions-item label="肖像照片" >
                        <span class="lookImg" @click="lookImg(teamDialog.operateInfo.PortraitPhoto)" v-if="teamDialog.operateInfo.PortraitPhoto">查看肖像照片</span>
                        <span v-else>无</span>
                    </el-descriptions-item>
                </el-descriptions>
                <template v-if="teamDialog.baseInfo.DeputationId">
                    <template v-if="teamDialog.baseInfo.TeamType == 2 && teamDialog.contactInfo">
                        <el-descriptions title="代表队联系人" :column="3" size="small" border direction="vertical" :labelStyle="labelStyle">
                            <el-descriptions-item label="姓名">{{teamDialog.contactInfo.Name}}</el-descriptions-item>
                            <el-descriptions-item label="手机号">{{teamDialog.contactInfo.Phone}}</el-descriptions-item>
                            <el-descriptions-item label="肖像照片">
                                <span class="lookImg" @click="lookImg(teamDialog.contactInfo.PortraitPhoto)" v-if="teamDialog.contactInfo.PortraitPhoto">查看肖像照片</span>
                                <span v-else>无</span>
                            </el-descriptions-item>
                        </el-descriptions>
                    </template>
                    <template v-if="[1,3].includes(teamDialog.baseInfo.TeamType) && teamDialog.DeputationOtherUsers && teamDialog.DeputationOtherUsers.length > 0">
                        <el-descriptions title="代表队其他人员"></el-descriptions>
                        <el-table 
                            :data="teamDialog.DeputationOtherUsers"
                            border
                            size="mini"
                            style="width: 100%"
                        >
                            <el-table-column label="序号" width="50" type="index" align="center"></el-table-column>
                            <el-table-column label="身份" min-width="100">
                                <template slot-scope="scope">
                                    <template v-for="(item,index) in scope.row.Roles">
                                        <span :key="index">{{item.RoleName}}</span>
                                        <template v-if="index < scope.row.Roles.length - 1">，</template>
                                    </template>
                                </template>
                            </el-table-column>
                            <el-table-column label="姓名" min-width="80">
                                <template slot-scope="scope">
                                    <span class="lookImg" @click="lookImg(scope.row.PortraitPhoto)">{{scope.row.Name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="性别" width="50" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.Gender">{{scope.row.Gender == 1 ? '男' : '女'}}</span>
                                    <span v-else>未知</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="手机号" min-width="100" prop="Phone"></el-table-column>
                            <el-table-column label="身份证件" min-width="180">
                                <template slot-scope="scope">
                                    <span class="lookImg" @click="lookImg(scope.row.IdentityPhoto1, scope.row.IdentityPhoto2)" v-if="scope.row.IdentityNo">{{scope.row.IdentityNo}}{{[1,3].includes(scope.row.IdentityType) ? '' : '（' + identityList[scope.row.IdentityType] + '）'}}</span>
                                    <span v-else>无</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="年龄" width="50" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.Age">{{scope.row.Age}}</span>
                                    <span v-else>未知</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </template>
                <template v-if="teamDialog.baseInfo.TeamType == 2">
                    <el-descriptions :title="teamDialog.baseInfo.DeputationName + '成员'"></el-descriptions>
                    <el-table
                        :data="teamDialog.members"
                        border
                        size="mini"
                        style="width: 100%"
                        :expand-row-keys="teamDialog.expandIds"
                        :row-key="getRowKey"
                        class="team_table"
                    >
                        <el-table-column label="序号" width="50" type="index" align="center" fixed></el-table-column>
                        <el-table-column label="身份" min-width="100" fixed>
                            <template slot-scope="scope">
                                <template v-for="(item,index) in scope.row.Roles">
                                    <span :key="index">{{item.RoleName}}</span>
                                    <template v-if="index < scope.row.Roles.length - 1">，</template>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名" min-width="80" fixed>
                            <template slot-scope="scope">
                                <span class="lookImg" @click="lookImg(scope.row.PortraitPhoto)">{{scope.row.Name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="性别" width="50" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Gender">{{scope.row.Gender == 1 ? '男' : '女'}}</span>
                                <span v-else>未知</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="手机号" prop="Phone" min-width="100"></el-table-column>
                        <el-table-column label="身份证件" min-width="180">
                            <template slot-scope="scope">
                                <span class="lookImg" @click="lookImg(scope.row.IdentityPhoto1, scope.row.IdentityPhoto2)" v-if="scope.row.IdentityNo">{{scope.row.IdentityNo}}{{[1,3].includes(scope.row.IdentityType) ? '' : '（' + identityList[scope.row.IdentityType] + '）'}}</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="年龄" width="50" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Age">{{scope.row.Age}}</span>
                                <span v-else>未知</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="球衣号码" prop="JerseyNumber" width="50" align="center" v-if="fieldsOptions.jersey_number > 0"></el-table-column>
                        
                        <template v-if="ExtraDataDefines.length > 0">
                            <el-table-column v-for="extraItem in ExtraDataDefines" :label="extraItem.Name" :min-width="ExtraDataColumn[extraItem.DataType] || 80" :key="extraItem.Field">
                                <template slot-scope="scope">
                                    <template v-if="['Date', 'DateTime'].includes(extraItem.DataType)">{{dateFormat(scope.row.Extras ? scope.row.Extras[extraItem.Field] : '', extraItem.DataType == 'Date' ? "yyyy-MM-dd" : "yyyy-MM-dd HH:mm")}}</template>
                                    <template v-else>{{scope.row.Extras ? (scope.row.Extras[extraItem.Field] || '') : ''}}</template>
                                </template>
                            </el-table-column>
                        </template>
                        <el-table-column label="操作" width="160">
                            <template slot-scope="scope" v-if="scope.row.IsAthlete">
                                <template v-if="scope.row.ImpeachTime">
                                    <el-button type="info" size="mini" @click="report(2, scope.row)">修改</el-button>
                                    <el-button type="danger" size="mini" @click="cancelReport(scope.row)">撤销</el-button>
                                </template>
                                <template v-else>
                                    <el-button type="danger" size="mini" @click="report(1, scope.row)">举报</el-button>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand" width="1">
                            <template slot-scope="scope">
                                <el-alert type="error" show-icon :closable="false"  v-if="scope.row.ImpeachTime && scope.row.IsAthlete">
                                    <template #title>该运动员于{{dateFormat(scope.row.ImpeachTime, "yyyy-MM-dd")}}被举报：{{scope.row.ImpeachReason}}</template>
                                </el-alert>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <template v-else-if="[1, 3].includes(teamDialog.baseInfo.TeamType)">
                    <template v-for="(item, index) in teamDialog.members">
                        <el-descriptions :title="teamDialog.baseInfo.TeamType == 1 ? '运动员信息' :`运动员${index + 1} 信息`" :column="4" size="small" border direction="vertical" :labelStyle="labelStyle" :key="index">
                            <template slot="extra">
                                <el-button 
                                    type="danger" 
                                    size="mini"
                                    @click="report(1, item)"
                                    v-if="!item.ImpeachTime && item.IsAthlete"
                                >举报运动员</el-button>
                                <template v-else>
                                    <el-button type="info" size="mini" @click="report(2, item)">修改</el-button>
                                    <el-button type="danger" size="mini" @click="cancelReport(item)">撤销</el-button>
                                </template>
                            </template>
                            <el-descriptions-item label="姓名">{{item.Name}}</el-descriptions-item>
                            <el-descriptions-item label="性别">
                                <span v-if="item.Gender">{{item.Gender == 1 ? '男' : '女'}}</span>
                                <span v-else>未知</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="身份">
                                <template v-for="(roleItem,roleIndex) in item.Roles">
                                    <span :key="roleIndex">{{roleItem.RoleName}}</span>
                                    <template v-if="roleIndex < item.Roles.length - 1">，</template>
                                </template>
                            </el-descriptions-item>
                            <el-descriptions-item label="手机号码">{{item.Phone}}</el-descriptions-item>
                            <el-descriptions-item label="肖像照片">
                                <span class="lookImg" @click="lookImg(item.PortraitPhoto)" v-if="item.PortraitPhoto">查看肖像照片</span>
                                <span v-else>无</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="证件类型">
                                <span v-if="item.IdentityNo">{{identityList[item.IdentityType]}}</span>
                                <span v-else>无</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="证件号码">
                                <span class="lookImg" @click="lookImg(item.IdentityPhoto1, item.IdentityPhoto2)" v-if="item.IdentityNo">{{item.IdentityNo}}</span>
                                <span v-else>无</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="年龄">
                                <span v-if="item.Age">{{item.Age}}</span>
                                <span v-else>未知</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="球衣号码" v-if="fieldsOptions.jersey_number > 0">{{item.JerseyNumber || '无'}}</el-descriptions-item>
                            <el-descriptions-item v-for="extraItem in ExtraDataDefines" :label="extraItem.Name" :key="extraItem.Field">
                                <template v-if="['Date', 'DateTime'].includes(extraItem.DataType)">{{dateFormat(item.Extras ? item.Extras[extraItem.Field] : '', extraItem.DataType == 'Date' ? "yyyy-MM-dd" : "yyyy-MM-dd HH:mm")}}</template>
                                <template v-else>{{item.Extras ? (item.Extras[extraItem.Field] || '') : ''}}</template>
                            </el-descriptions-item>
                            <el-descriptions-item v-for="i in replenishLength" :key="i"></el-descriptions-item>
                        </el-descriptions>
                        <el-alert type="error" show-icon :closable="false"  v-if="item.ImpeachTime && item.IsAthlete">
                            <template #title>该运动员于{{dateFormat(item.ImpeachTime, "yyyy-MM-dd")}}被举报：{{item.ImpeachReason}}</template>
                        </el-alert>
                    </template>
                </template>
            </div>
            <template #footer>
                <el-descriptions :column="3" :labelStyle="{...labelStyle, width: '120px'}">
                    <el-descriptions-item label="审核状态">
                        <span :style="['','','color:#67C23A','color:#F56C6C'][teamDialog.baseInfo.AuditStatus]">{{['未提交','待审核','审核通过','审核不通过'][teamDialog.baseInfo.AuditStatus]}}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="审核时间">{{dateFormat(teamDialog.baseInfo.AuditTime, "yyyy-MM-dd HH:mm")}}</el-descriptions-item>
                    <el-descriptions-item label="提交审核时间">{{dateFormat(teamDialog.baseInfo.SubmitTime, "yyyy-MM-dd HH:mm")}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions :column="3" :labelStyle="{...labelStyle, width: '120px'}" v-if="teamDialog.baseInfo.LastAuditStatus && !([2,3].includes(teamDialog.baseInfo.AuditStatus))">
                    <el-descriptions-item label="上次审核状态">
                        <span :style="['','','color:#67C23A','color:#F56C6C'][teamDialog.baseInfo.LastAuditStatus]">{{['','','审核通过','审核不通过'][teamDialog.baseInfo.LastAuditStatus]}}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="上次审核时间" :span="2">{{dateFormat(teamDialog.baseInfo.AuditTime, "yyyy-MM-dd HH:mm")}}</el-descriptions-item>
                </el-descriptions>
                <el-descriptions :column="1" :labelStyle="{...labelStyle, width: '120px'}" v-if="teamDialog.baseInfo.AuditRejectReason">
                    <el-descriptions-item label="审核不通过原因" v-if="teamDialog.baseInfo.AuditRejectReason">
                        <el-input type="textarea" resize="none" :value="teamDialog.baseInfo.AuditRejectReason" style="width: 100%;max-width:400px;"></el-input>
                    </el-descriptions-item>
                </el-descriptions>
                <div class="dialog-footer">
                    <template v-if="!teamDialog.isDelete">
                        <div>
                            <el-button type="danger" @click="deleteTeam(1, teamDialog.baseInfo)">强制删除</el-button>
                        </div>
                        <div v-if="[1].includes(teamDialog.baseInfo.AuditStatus)">
                            <el-button type="success" @click="audit()">审核通过</el-button>
                            <el-button type="danger" @click="noAudit()">审核不通过</el-button>
                        </div>
                        <div v-else-if="[3].includes(teamDialog.baseInfo.AuditStatus)">
                            <el-button type="success" @click="audit()">改为审核通过</el-button>
                        </div>
                        <div v-else-if="[2].includes(teamDialog.baseInfo.AuditStatus)">
                            <el-button type="danger" @click="noAudit()">改为审核不通过</el-button>
                        </div>
                        <div v-else></div>
                    </template>
                    <template v-else>
                        <div>
                            <el-button type="danger" @click="deleteTeam(2, teamDialog.baseInfo)">释放名额</el-button>
                        </div>
                    </template>
                    <div>
                        <el-button @click="teamDialog.show = false">关&ensp;闭</el-button>
                    </div>
                </div>
            </template>
        </el-dialog>
        <el-dialog title="名额总数设置" :visible.sync="groupLimitDialog.show" width="400px">
            <el-form ref="form" size="small" :model="groupLimitDialog" :rules="rules">
                <el-form-item label="组别名称：">{{groupLimitDialog.groupInfo.Name}}</el-form-item>
                <el-form-item label="名额限制：" prop="EnrollQuotaLimit">
                    <el-radio-group v-model="groupLimitDialog.EnrollQuotaLimitRadio">
                        <el-radio :label="false">不限</el-radio>
                        <el-radio :label="true">
                            限制最多
                            <el-input type="number" v-model.number="groupLimitDialog.EnrollQuotaLimit" @change="enrollQuotaLimitChange" style="width: 50px"></el-input>
                            <template v-if="groupLimitDialog.groupInfo.GroupType == 1">名运动员</template>
                            <template v-else-if="groupLimitDialog.groupInfo.GroupType == 2">支队伍</template>
                            <template v-else-if="groupLimitDialog.groupInfo.GroupType == 3">对组合</template>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <template #footer>
                <div style="display: flex;justify-content: space-between;">
                    <el-button @click="groupLimitDialog.show = false">取消</el-button>
                    <el-button type="primary" @click="confirmGroupLimit()">确认</el-button>
                </div>
            </template>
        </el-dialog> 
        <el-dialog title="报名操作员信息" :visible.sync="operateDialog.show" width="400px">
            <div class="operateInfo" v-if="operateDialog.detail">
                <div class="image">
                    <img :src="operateDialog.detail.PortraitPhoto" @click="lookImg(operateDialog.detail.PortraitPhoto)">
                </div>
                <el-descriptions :column="1" :labelStyle="labelStyle">
                    <el-descriptions-item label="姓名">{{operateDialog.detail.Name}}</el-descriptions-item>
                    <el-descriptions-item label="手机号">{{operateDialog.detail.Phone}}</el-descriptions-item>
                    <el-descriptions-item label="身份" >
                        <span v-if="groupLimitDialog.groupInfo.groupType == 2">{{operateDialog.detail.EnrollRoleList.map(item=>item.RoleName).join('，')}}</span>
                        <span v-else>个人报名</span>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
        </el-dialog> 
        <el-image ref="imagePreview" class="image_preview"
            src="~@/assets/images/logo.png" 
            :preview-src-list="imagePreviews">
        </el-image>
    </div>
</template>
<script>
import {
    GetLeagueEnrollTeamsNumberStatistics,
    GetLeagueEnrollOccupyQuotaTeamsList,
    SetLeagueEnrollGroupQuotaLimit,
    GetLeagueEnrollTeamOperator,
    GetLeagueEnrollTeamDetail,
    ForceDeleteLeagueEnrollTeam,
    ApproveLeagueEnrollTeam, //报名参赛审核通过
    RejectLeagueEnrollTeam, //报名参赛审核不通过
    ImpeachEnrollTeamMember,//举报参赛运动员
    CancelImpeachEnrollTeamMember,//撤销举报参赛运动员
} from '@/api'
import {
    GetLeagueEnrollFieldsOptions
} from '@/api/enroll';
import {dateFormat} from '@/assets/js';
export default {
    data(){
        return {
            subLeagueId: 0,
            labelStyle: {'width':'80px','justify-content': 'end','padding-right':'12px','margin-right':'0','box-sizing':'border-box'},
            list: [],
            loading: false,
            dateTime: '',
            teamDialog:{
                show: false,
                isDelete: true,
                baseInfo: {},
                operateInfo: null,
                contactInfo: null,
                members: [],
                ThisGroupDeputationEnrollNum: 0,
                DeputationOtherUsers: []
            },
			fieldsOptions: {},
            ExtraDataDefines: [],
            ExtraDataColumn: {
                'DateTime': 140
            },            
            imagePreviews:[],
            groupDialog:{
                show: false,
                list: [],
                type: 0,
                groupInfo: {}
            },
            groupLimitDialog:{
                show: false,
                EnrollQuotaLimitRadio: false,
                EnrollQuotaLimit: '',
                groupInfo: {}
            },
            operateDialog:{
                show: false,
                detail: null
            }
        }
    },
    created(){
        let subLeagueId = +this.$route.params.subLeagueId;
        this.subLeagueId = subLeagueId;
        this.getDataList();
        GetLeagueEnrollFieldsOptions({
            SubLeagueId: this.subLeagueId
        }).then(data=>{
            if(data.Code == 0){
                this.fieldsOptions = data.FieldsOptions || {};
                this.ExtraDataDefines = data.ExtraDataDefines || [];
            }
        })
    },
    computed: {
        identityList(){
            return {
                1:'身份证（港澳台居住证）',
                2:'护照',
                4:'台湾居民来往大陆通行证',
                5:'港澳居民来往内地通行证'
            }
        },
        rules(){
            return {
                EnrollQuotaLimit:[
                    {validator:(rule, value, callback)=>{
                        if(this.groupLimitDialog.EnrollQuotaLimitRadio){
                            if(value && (value < 1 || value > 9999)){
                                callback(new Error('只能输入1~9999的正整数'));
                            }else{
                                callback();
                            }
                        }else{
                            callback();
                        }
                    }}
                ] 
            }
        },
        replenishLength(){
            let len = (this.ExtraDataDefines.length + (this.fieldsOptions.jersey_number > 0 ? 1 : 0)) % 4;         
            if(len == 0) return 0;
            return 4 - len;
        }
         
    },
    methods:{
        dateFormat(value, format){
            if(!value) return '';
            return dateFormat(value, format) || '';
        },
        getRowKey(row){
            return row.IsAthlete ? `Athlete-${row.UserId}` : row.UserId;
        },
        getDataList(){
            this.loading = true;
            GetLeagueEnrollTeamsNumberStatistics({
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                this.loading = false;
                if(data.Code == 0){
                    this.dateTime = dateFormat(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    this.list = data.StatisticsList || [];
                }
            }).catch(()=>{
                this.loading = false;
            })
        },
        openEditLimit(row){
            this.$set(this, 'groupLimitDialog', {
                show: true,
                EnrollQuotaLimitRadio: !!row.TotalNum,
                EnrollQuotaLimit: row.TotalNum || '',
                groupInfo: row.GroupInfo
            })
        },
        enrollQuotaLimitChange(value){
            if(!+value){
                this.$set(this.groupLimitDialog, 'EnrollQuotaLimitRadio', false);
            }else{
                this.$set(this.groupLimitDialog, 'EnrollQuotaLimitRadio', true);
            }
        },
        confirmGroupLimit(){
            this.$refs.form.validate((valid)=>{
                if(valid){
                    let {
                        groupInfo,
                        EnrollQuotaLimitRadio,
                        EnrollQuotaLimit
                    } = this.groupLimitDialog;
                    let TotalNum = null;
                    if(EnrollQuotaLimitRadio){
                        TotalNum = +EnrollQuotaLimit;
                    }
                    SetLeagueEnrollGroupQuotaLimit({
                        SubLeagueId: this.subLeagueId,
                        GroupId: groupInfo.Id,
                        TotalNum
                    }).then(data=>{
                        if(data.Code == 0){
                            this.$message.success(groupInfo.Name + '名额修改成功');
                            this.$set(this.groupLimitDialog, 'show', false);
                            this.getDataList();
                        }
                    })
                }else{
                    this.$message.error('填写信息有误，请查看！');
                }
            })
        },
        openGroupDetail(type, groupInfo){
            GetLeagueEnrollOccupyQuotaTeamsList({
                SubLeagueId: this.subLeagueId,
                GroupId: groupInfo.Id,
                QueryFlag: type
            }).then(data=>{
                if(data.Code == 0){
                    let list = data.Teams || [];
                    if([1, 3].includes(groupInfo.GroupType)){
                        let spanArr = [];
                        let position = 0;
                        for (let i = 0; i < list.length; i++) {
                            if (i === 0) {
                                spanArr.push(1);
                            } else {
                                let obj = list[i],
                                    prevObj = list[i - 1];
                                if (obj.DeputationName === prevObj.DeputationName && obj.OccupyNum === prevObj.OccupyNum && obj.CompanyName === prevObj.CompanyName) {
                                    spanArr[position] += 1;
                                    spanArr.push(0);
                                } else {
                                    spanArr.push(1);
                                    position = i;
                                }
                            }
                        }
                        list = list.map((item,index)=>({...item, _rowspan: spanArr[index]}));
                    }
                    this.$set(this, 'groupDialog', {
                        show: true,
                        list,
                        type,
                        groupInfo
                    })
                }
            })
        },
        openTeamDetail(row){
            let groupType = this.groupDialog.groupInfo.GroupType;
            GetLeagueEnrollTeamDetail({
                SubLeagueId: this.subLeagueId,
                TeamId: row.TeamId
            }).then(data=>{
                if(data.Code == 0){
                    let members = data.Members || [],
                        expandIds = [];
                    if(groupType == 2){
                        expandIds = members.filter(item=>item.ImpeachTime && item.IsAthlete).map(item=>`Athlete-${item.UserId}`);
                    }
                    this.$set(this, 'teamDialog', {
                        show: true,
                        isDelete: false,
                        baseInfo: data.BaseInfo,
                        operateInfo: data.DeputationOperateUser,
                        contactInfo: data.DeputationLinkUser,
                        members,
                        ThisGroupDeputationEnrollNum: data.ThisGroupDeputationEnrollNum,
                        DeputationOtherUsers: data.DeputationOtherUsers,
                        expandIds
                    })
                }else if(data.Code == 3893){
                    this.openGroupDetail(this.groupDialog.type, this.groupDialog.groupInfo);
                    this.$message.error(`该${['个人运动员','队伍','组合'][groupType - 1]}记录已被删除！`);
                }else if(data.Code == 3894){
                    this.openTeamDetail(row);
                    this.$message.error(`该${['个人运动员','队伍','组合'][groupType - 1]}记录已被修改！`);
                }else if(data.Code == 3900){
                    this.$set(this, 'teamDialog', {
                        show: true,
                        isDelete: true,
                        baseInfo: data.BaseInfo,
                        operateInfo: null,
                        contactInfo: null,
                        members: [],
                        ThisGroupDeputationEnrollNum: 0,
                        DeputationOtherUsers: [],
                        expandIds: []
                    })
                }
            })
        },
        openOperate(row){
            GetLeagueEnrollTeamOperator({
                SubLeagueId: this.subLeagueId,
                TeamId: row.TeamId
            }).then(data=>{
                if(data.Code == 0){
                    this.$set(this, 'operateDialog', {
                        show: true,
                        detail: data.EnrollOperator
                    })
                }
            })
        },
        deleteTeam(type, {TeamId, TeamType}){
            let title = '强制删除',
                message = `<p>该操作将从报名系统中删除此${['个人运动员','队伍','组合'][TeamType - 1]}，同时释放其占用的名额。</p>
                        <p>该操作无法撤销，是否执行？</p>`
            if(type == 2){
                title = '释放名额';
                message = '释放该操作者占用的名额？';
            }
            this.$confirm(message, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                ForceDeleteLeagueEnrollTeam({
                    SubLeagueId: this.subLeagueId,
                    TeamId: TeamId
                }, type == 1 ? '强制删除中' : '名额释放中').then(data=>{
                    if(data.Code == 0){
                        this.$set(this.teamDialog, 'show', false);
                        this.openGroupDetail(this.groupDialog.type, this.groupDialog.groupInfo);
                        this.getDataList();
                        this.$message.success(type == 1 ? '强制删除成功' : '名额释放成功');
                    }
                })
            })
        },
        lookImg(){
            var imgs = [...arguments].filter(item=>item);
            if(imgs.length == 0){
                this.$message.warning('此队员未上传照片');
            }else{
                this.imagePreviews = imgs;
                this.$refs.imagePreview.showViewer = true;
            }
        },
        report(type, {UserId, ImpeachReason, ImpeachTime}){
            let detail = this.teamDialog;
            let title = '举报运动员',
                message = '举报原因：';
            if(type == 2){
                title = '修改举报原因';
                message = `<div style="display:flex;justify-content: space-between;">
                    <span>举报原因：</span>
                    <span>举报时间：${dateFormat(ImpeachTime, "yyyy-MM-dd HH:mm")}</span>
                </div>`;
            }
            this.$prompt(message, title, {
                dangerouslyUseHTMLString: true,
                confirmButtonText: type == 2 ? '保存修改' : '举报',
                cancelButtonText: '取消',
                inputType: 'textarea',
                inputValue: ImpeachReason,
                inputValidator: (value)=>{
                    if(!value){
                        return '请输入举报原因'
                    }
                }
            }).then(({ value }) => {
                ImpeachEnrollTeamMember({
                    "TeamId": detail.baseInfo.TeamId,
                    "AthlelteUserId": UserId,
                    "ImpeachReason": value
                }).then(data=>{
                    if(data.Code == 0){
                        this.$message.success('操作成功');
                        this.openTeamDetail({TeamId: detail.baseInfo.TeamId});
                    }else if(data.Code == 3893){
                        detail.show = false;
                        this.openGroupDetail(this.groupDialog.type, this.groupDialog.groupInfo);
                        this.getDataList();
                        this.$message.error(`该运动员记录已被删除！`);
                    }else if(data.Code == 3894){
                        this.openTeamDetail({TeamId: detail.baseInfo.TeamId});
                        this.$message.error(`该运动员记录已被修改！`);
                    }
                })
            }).catch(() => {      
            });
        },
        cancelReport({UserId}){
            let detail = this.teamDialog;
            CancelImpeachEnrollTeamMember({
                "TeamId": detail.baseInfo.TeamId,
                "AthlelteUserId": UserId
            }).then(data=>{
                if(data.Code == 0){
                    this.$message.success('撤销成功');
                    this.openTeamDetail({TeamId: detail.baseInfo.TeamId});
                }else if(data.Code == 3893){
                    detail.show = false;
                    this.openGroupDetail(this.groupDialog.type, this.groupDialog.groupInfo);
                    this.getDataList();
                    this.$message.error(`该运动员记录已被删除！`);
                }else if(data.Code == 3894){
                    this.openTeamDetail({TeamId: detail.baseInfo.TeamId});
                    this.$message.error(`该运动员记录已被修改！`);
                }
            })
        },
        audit(){
            let detail = this.teamDialog;
            ApproveLeagueEnrollTeam({
                "SubLeagueId": this.subLeagueId,
                "TeamId": detail.baseInfo.TeamId,
                "SubmitTime": detail.baseInfo.SubmitTime
            }).then(data=>{
                if(data.Code == 0){
                    this.$message.success('操作成功');
                    this.openTeamDetail({TeamId: detail.baseInfo.TeamId});
                }else if(data.Code == 3893){
                    detail.show = false;
                    this.openGroupDetail(this.groupDialog.type, this.groupDialog.groupInfo);
                    this.getDataList();
                    this.$message.error(`该${['个人运动员','队伍','组合'][detail.baseInfo.TeamType - 1]}记录已被删除！`);
                }else if(data.Code == 3894){
                    this.openTeamDetail({TeamId: detail.baseInfo.TeamId});
                    this.$message.error(`该${['个人运动员','队伍','组合'][detail.baseInfo.TeamType - 1]}记录已被修改！`);
                }
            })
        },
        noAudit(){
            let detail = this.teamDialog;
            this.$prompt('审核不通过的原因：', '审核不通过', {
                confirmButtonText: '审核不通过',
                cancelButtonText: '取消',
                inputType:'textarea',
                inputValidator:(value)=>{
                    if(!value){
                        return '请输入审核不通过的原因'
                    }
                }
            }).then(({ value }) => {
                RejectLeagueEnrollTeam({
                    "SubLeagueId": this.subLeagueId,
                    "TeamId": detail.baseInfo.TeamId,
                    "SubmitTime": detail.baseInfo.SubmitTime,
                    "RejectReason": value
                }).then(data=>{
                    if(data.Code == 0){
                        this.$message.success('操作成功');
                        this.openTeamDetail({TeamId: detail.baseInfo.TeamId});
                    }else if(data.Code == 3893){
                        detail.show = false;
                        this.openGroupDetail(this.groupDialog.type, this.groupDialog.groupInfo);
                        this.getDataList();
                        this.$message.error(`该${['个人运动员','队伍','组合'][detail.baseInfo.TeamType - 1]}记录已被删除！`);
                    }else if(data.Code == 3894){
                        this.openTeamDetail({TeamId: detail.baseInfo.TeamId});
                        this.$message.error(`该${['个人运动员','队伍','组合'][detail.baseInfo.TeamType - 1]}记录已被修改！`);
                    }
                })
            }).catch(() => {      
            });
        },
    }
}
</script>
<style scoped>
.EnrollAuditDetail_content{
    padding-right: 10px;
    box-sizing: border-box;
}
.error{
    color: red;
}
.allow{
    color: #409EFF;
}
.full{
    color: rgb(255, 187, 0);
}
.operateInfo{
    display: flex;
}
.operateInfo .image img{
    width: 100px;
    height: auto;
    margin-right: 10px;
}
.operateInfo .el-descriptions{
    margin-top: 0;
}
    .cell .el-button--text{
        padding: 0;
    }
    .form .el-row{
        margin-bottom: 0 !important;
    }
    .el-descriptions{
        margin-top: 20px;
    }
    .el-descriptions:first-of-type{
        margin-top: 0;
    }
    .el-descriptions::v-deep .el-descriptions__header{
        margin-bottom: 10px;
    }
    .lookImg{
        color: #409EFF;
        cursor: pointer;
    }
    .dialog-footer{
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .image_preview{
        display: none;
    }
    .el-alert{
        border-radius: 0;
    }
    .team_table::v-deep .el-table__expanded-cell{
        padding: 0;
    }
    .team_table::v-deep .el-table__expand-column{
        pointer-events: none;
    }
    .team_table::v-deep .el-table__expand-column .cell{
        display: none;
    }
</style>
<style>
    .detail_dialog{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .detail_dialog .el-dialog{
        width: 80%;
        max-width: 1000px;
        margin: 0 !important;
    }
    .detail_dialog .el-dialog .el-dialog__body{
        max-height: calc(80vh - 54px - 126px);
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>